import React from 'react'
import i18n from 'live/services/i18n'
import widgetsService from 'live/services/widgets'
import EditorService from 'live/services/editor'
import WidgetReducer from './widgetReducer'
import { reactWidgetWrapper } from 'live/widgets/decorators/react'

import { withSuspenseWrapper } from '../../components/SuspenseWrapper'
import WrapperEditor from './editor'

const WrapperBoxplotImpl = withSuspenseWrapper(React.lazy(() => import('./WidgetImpl')))

export const REDUCER_LATEST = '@latest'

const widgetType = 'kpi-boxplot'

const policies = {
    legends: false,
    restrictViewModeOptionsHeight: true,
    allowHideTooltip: false,
    handleOwnMissingData: false,
    allowXAxisConfig: false,
    allowYAxisConfig: false
}

const DEFAULT_CHART_CONFIG = {
    spanFinal: false,
    chartConfig: {}
}

const EditorInfo = {
    label: 'Box Plot for KPIs',
    order: 26,
    type: `${widgetType}-editor`,
    description: i18n('Box Plot for Rigs and Wells Performance'),
    iconClass: 'far fa-tasks'
}

EditorService.newEditor({
    name: EditorInfo.type,
    editor: WrapperEditor,
    defaultWidgetType: widgetType
})

EditorService.newEditorMenuOption(widgetType, EditorInfo)

widgetsService.impl(widgetType, reactWidgetWrapper(WrapperBoxplotImpl, WidgetReducer))
widgetsService.queryHandlerKind(widgetType, widgetType)
widgetsService.config(widgetType, DEFAULT_CHART_CONFIG)
widgetsService.policies(widgetType, policies)
widgetsService.editor(widgetType, EditorInfo.type)
widgetsService.ui(widgetType, { editor: EditorInfo.type })
